/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import EmptyBuilding from 'svg/galax/building/empty';


export default ({ geometry }) =>
{
  const size = geometry.getHex().getEntitySize();

  return <EmptyBuilding center size = {size} />;
}
